/* snippet: https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71 */
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import './styles.scss'

export class Counter extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {}
  }

  insertApostrophs(numberToFormat) {
    const theNum = numberToFormat.toString()
    let newNum = 0
    if (theNum.length > 6) {
      const rawNewNum =
        theNum.substring(0, theNum.length - 6) + "'" + theNum.slice(-6)
      newNum =
        rawNewNum.substring(0, rawNewNum.length - 3) + "'" + rawNewNum.slice(-3)
    } else if (theNum.length > 4) {
      newNum = theNum.substring(0, theNum.length - 3) + "'" + theNum.slice(-3)
    } else {
      newNum = theNum
    }
    return newNum
  }

  render() {
    // console.log('totalVaccinations:', this.props.totalVaccinations)
    return (
      <div className='counter-wrapper'>
        <div className='counter'>
          {this.props.totalVaccinations === 0 && (
            <div className='ui active centered inline small loader' />
          )}
          <div className='big-number'>
            {this.props.totalVaccinations > 0 &&
              this.insertApostrophs(parseInt(this.props.totalVaccinations))}
          </div>
          <div className='unit'>Impfdosen</div>
          <div className='explain'>
            wurden in der Schweiz* bereits verabreicht.
            <p className='disclaim'>
              *ohne Dosen, die in der Schweizer Armee oder im Fürstentum
              Liechtenstein verabreicht wurden.
            </p>
          </div>
        </div>
      </div>
    )
  }
}
